import { ReactNode } from "react";
import MonthlySchedule from "./components/MonthlySchedule/MonthlySchedule";
import WeeklySchedule from "./components/WeeklySchedule/WeeklySchedule";
import DailySchedule from "./components/DailySchedule/DailySchedule";
import useTranslate from "ui/locale/hooks/useTranslate";
import { LocaleTranslationResource } from "ui/locale/i18n.types";

export interface SchedulingTypeChildProps {
    onChange?: (value: string | number) => void;
}

export enum ScheduledRedeemPeriodicity {
    DAILY = "daily",
    WEEKLY = "weekly",
    MONTHLY = "monthly",
}

interface SchedulingType {
    label: LocaleTranslationResource;
    value: string;
    child: (props?: SchedulingTypeChildProps) => ReactNode;
}

export const schedulingTypeGroup: SchedulingType[] = [
    {
        label: "monthly",
        value: ScheduledRedeemPeriodicity.MONTHLY,
        child: (props) => <MonthlySchedule {...props} />,
    },
    {
        label: "weekly",
        value: ScheduledRedeemPeriodicity.WEEKLY,
        child: (props) => <WeeklySchedule {...props} />,
    },
    {
        label: "daily",
        value: ScheduledRedeemPeriodicity.DAILY,
        child: () => <DailySchedule />,
    },
];

export function useSchedulingTypeGroup() {
    const translate = useTranslate();
    return { schedulingTypeGroup: schedulingTypeGroup.map((item) => ({ ...item, label: translate(item.label) })) };
}
